module.exports = __webpack_public_path__ + "images/emoji/innocent.ba98baa521e6f8f62686.png";